import classNames from "classnames";

// Icons
import Star from "assets/icons/favorite-star.svg?react";

import "./styles.sass";

type ButtonFavoriteProps = {
  favorite: boolean;
  onClick: () => void;
};

const ButtonFavorite = (props: ButtonFavoriteProps) => {
  const { favorite, onClick } = props;

  const ButtonFavoriteClass = classNames("ButtonFavorite", {
    favorite,
  });

  return (
    // eslint-disable-next-line jsx-a11y/control-has-associated-label, react/jsx-handler-names
    <button type="button" className={ButtonFavoriteClass} onClick={onClick}>
      <Star />
    </button>
  );
};

export default ButtonFavorite;
